import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { ArrowLeft, Users, Target, Shield, MessageSquare } from 'lucide-react';

const About = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-3xl mx-auto px-4 py-8">
        {/* Back button */}
        <Button
          variant="ghost"
          onClick={() => navigate(-1)}
          className="mb-6"
          data-testid="about-back-btn"
        >
          <ArrowLeft className="h-4 w-4 mr-2" />
          Back
        </Button>

        {/* Header */}
        <div className="bg-white rounded-xl shadow-sm p-8 mb-6">
          <h1 className="text-3xl font-bold text-gray-900 mb-4">About POLIVOX</h1>
          <div className="w-16 h-1 bg-gradient-to-r from-blue-600 to-purple-600 rounded-full mb-6"></div>
          
          <p className="text-lg text-gray-700 leading-relaxed mb-6">
            POLIVOX is a civic engagement platform where citizens can express their opinions, 
            discuss public issues, and engage in constructive debates.
          </p>
          
          <p className="text-gray-600 leading-relaxed">
            Our mission is to empower individuals to raise their voice, stay informed, and 
            contribute to meaningful conversations that shape society.
          </p>
        </div>

        {/* Mission Cards */}
        <div className="grid md:grid-cols-2 gap-4 mb-6">
          <div className="bg-white rounded-xl shadow-sm p-6">
            <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center mb-4">
              <Users className="h-6 w-6 text-blue-600" />
            </div>
            <h3 className="text-lg font-semibold text-gray-900 mb-2">Community Driven</h3>
            <p className="text-gray-600 text-sm">
              Built by citizens, for citizens. Every voice matters in shaping public discourse.
            </p>
          </div>
          
          <div className="bg-white rounded-xl shadow-sm p-6">
            <div className="w-12 h-12 bg-purple-100 rounded-lg flex items-center justify-center mb-4">
              <Target className="h-6 w-6 text-purple-600" />
            </div>
            <h3 className="text-lg font-semibold text-gray-900 mb-2">Neutral Platform</h3>
            <p className="text-gray-600 text-sm">
              POLIVOX is a neutral platform. All content is user-generated and does not represent any political party or organization.
            </p>
          </div>
          
          <div className="bg-white rounded-xl shadow-sm p-6">
            <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center mb-4">
              <Shield className="h-6 w-6 text-green-600" />
            </div>
            <h3 className="text-lg font-semibold text-gray-900 mb-2">Transparent</h3>
            <p className="text-gray-600 text-sm">
              We aim to build a transparent, respectful, and informed digital space for public discourse.
            </p>
          </div>
          
          <div className="bg-white rounded-xl shadow-sm p-6">
            <div className="w-12 h-12 bg-amber-100 rounded-lg flex items-center justify-center mb-4">
              <MessageSquare className="h-6 w-6 text-amber-600" />
            </div>
            <h3 className="text-lg font-semibold text-gray-900 mb-2">Constructive Debate</h3>
            <p className="text-gray-600 text-sm">
              Engage in meaningful discussions and debates that contribute to positive change.
            </p>
          </div>
        </div>

        {/* Footer note */}
        <div className="text-center text-gray-500 text-sm">
          <p>Thank you for being part of POLIVOX.</p>
        </div>
      </div>
    </div>
  );
};

export default About;
